import { Locale } from "../Locale.js";
import { localizePathMap } from "./localizePathMap.js";

export const ourApproachPathMap = localizePathMap({
	[Locale.cs]: "nas-pristup",
	[Locale.en]: "our-approach",
});
